import {Injectable} from '@angular/core';
import {FromProviderResolverService} from '@abstract/from-provider-resolver.service';
import {ObjectsData, ObjectsProvider} from '@providers/objects/objects.provider';

/**
 * Резолвер списка объектов, чтобы подгрузить данные до того как примаунтится компонент, которому эти данные нужны
 */

@Injectable()
export class ObjectsResolverService extends FromProviderResolverService<ObjectsData> {

    protected cacheData = true;

    constructor(
        provider: ObjectsProvider,
    ) {
        super(provider);
    }
}
